import React from 'react';

import { Button, IconSvg } from '@utex/ui-kit';
import { getTransparentButtonColor } from '../HeaderButtons/buttonsView';

import { ViewType } from '../../types';

export interface Props {
  openSideMenu: () => void;
  view: ViewType;
}

export const MenuButton = (props: Props) => {
  const { view, openSideMenu } = props;
  return (
    <Button
      view={getTransparentButtonColor(view)}
      isBlured={view !== 'default'}
      shape="circle"
      onClick={(e) => {
        e.stopPropagation();
        openSideMenu && openSideMenu();
      }}
      aria-label="menu button"
      data-testid="menu-btn"
    >
      <IconSvg src="menu" />
    </Button>
  );
};
